import React, { useState, useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import {
  changeStr,
  getChoiceValues,
  getChoiceLabel,
  useWindowDimensions,
  isSchemaValid,
  useDirectTransCheck,
  isFatalApiError,
  useIECheck,
  postHeightToParent,
} from 'utils';

import PresentPC from 'components/pages/Conf/PresentPC';
import PresentSP from 'components/pages/Conf/PresentSP';

import { postRegisterOrderApi } from 'utils/api';
import {
  STATION_URL,
  TYPE_URL,
  SKILL_URL,
  COND_URL,
  INFO_URL,
  THANKS_URL,
  ACKNOWLEDGE_MAP,
} from 'utils/constant';


import AppContext from 'fluxes/context';
import { CHANGE_MODIFY_MODE, CHANGE_VALID } from 'fluxes/actions';

const Conf = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  const history = useHistory();
  const [ isApiError, setIsApiError ] = useState(false);
  const [ showLoading, setShowLoding ] = useState(false);
  const [ modalIsOpen, setModalIsOpen ] = useState(false);

  useDirectTransCheck({ state });

  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;
  const pageEl = useRef(null);

  const {
    ekiCd,
    ekiName,
    moveTypeCd,
    moveTime,
    moveTimeFromBusStop,
    physicalCare,
    lifeSupport,
    otherWorkText,
    qualification,
    qualificationText,
    experience,
    suggestHourSalary,
    workStyle,
    fromDate,
    pendingFromDateFlag,
    toDate,
    pendingToDateFlag,
    minBusinessDay,
    maxBusinessDay,
    dayOfTheWeek,
    workStyleKbn,
    earlyShiftStartHour, // 早番
    earlyShiftStartMin,
    earlyShiftEndHour,
    earlyShiftEndMin,
    earlyShiftRestTime,
    dayShiftStartHour, // 日勤
    dayShiftStartMin,
    dayShiftEndHour,
    dayShiftEndMin,
    dayShiftRestTime,
    lateShiftStartHour, // 遅番
    lateShiftStartMin,
    lateShiftEndHour,
    lateShiftEndMin,
    lateShiftRestTime,
    nightShiftStartHour, // 夜勤
    nightShiftStartMin,
    nightShiftEndHour,
    nightShiftEndMin,
    nightShiftRestTime,
    fixedStartHour, // 固定勤務
    fixedStartMin,
    fixedEndHour,
    fixedEndMin,
    fixedRestTime,
    canCommuteByCar,
    hourSalary,
    freeComment,
    corpName,
    facilityName,
    facilityType,
    capacity,
    userName,
    tel,
    email,
    zip,
    municipality,
    houseNumber,
    isRegistered,
  } = state;

  // Post データ用に文字列を作成
  const fromDateStr = changeStr(fromDate);
  const toDateStr = changeStr(toDate);
  const fixedStartTime = `${fixedStartHour}:${fixedStartMin}`;
  const fixedEndTime = `${fixedEndHour}:${fixedEndMin}`;
  const earlyShiftStartTime = `${earlyShiftStartHour}:${earlyShiftStartMin}`;
  const earlyShiftEndTime = `${earlyShiftEndHour}:${earlyShiftEndMin}`;
  const dayShiftStartTime = `${dayShiftStartHour}:${dayShiftStartMin}`;
  const dayShiftEndTime = `${dayShiftEndHour}:${dayShiftEndMin}`;
  const lateShiftStartTime = `${lateShiftStartHour}:${lateShiftStartMin}`;
  const lateShiftEndTime = `${lateShiftEndHour}:${lateShiftEndMin}`;
  const nightShiftStartTime = `${nightShiftStartHour}:${nightShiftStartMin}`;
  const nightShiftEndTime = `${nightShiftEndHour}:${nightShiftEndMin}`;
  
  let workStyleInfo = [];
  const shiftInfo = [];
  const shiftTitle = [];
  workStyleKbn.map((num)=>{
    if(num === '02'){
      shiftInfo.push({ workStyleKbn: num, startTime: earlyShiftStartTime, endTime: earlyShiftEndTime, restTime: Number(earlyShiftRestTime) });
      shiftTitle.push('就業時間(早番)');
    }else if(num === '03'){
      shiftInfo.push({ workStyleKbn: num, startTime: dayShiftStartTime, endTime: dayShiftEndTime, restTime: Number(dayShiftRestTime) });
      shiftTitle.push('就業時間(日勤)');
    }else if(num === '04'){
      shiftInfo.push({ workStyleKbn: num, startTime: lateShiftStartTime, endTime: lateShiftEndTime, restTime: Number(lateShiftRestTime) });
      shiftTitle.push('就業時間(遅番)');
    }else if(num === '05'){
      shiftInfo.push({ workStyleKbn: num, startTime: nightShiftStartTime, endTime: nightShiftEndTime, restTime: Number(nightShiftRestTime) });
      shiftTitle.push('就業時間(夜勤)');
    }
    return shiftInfo;
  });
  const fixedInfo = [ { workStyleKbn: '01', startTime: fixedStartTime, endTime: fixedEndTime, restTime: Number(fixedRestTime) } ];

  if(workStyle === '01'){
    workStyleInfo = fixedInfo;
  }else{
    workStyleInfo = shiftInfo;
  }
  const address = `${municipality} ${houseNumber}`;
  
  // 修正モードON
  const changeModifyMode = () => dispatch({
    type: CHANGE_MODIFY_MODE,
    isModify: true,
  });

  useEffect(() => 
    // 遷移時に修正モードON
    dispatch({
      type: CHANGE_MODIFY_MODE,
      isModify: true,
    }), [ dispatch ]);

  // LP埋め込み時の高さ送信
  useEffect(() => {
    if(state.lpMode){
      postHeightToParent(state.lpOrigin, pageEl.current.clientHeight);
    }
  }, [ state.lpMode, state.lpOrigin, pageEl ]);

  // ボタン押下
  // モーダル表示
  const onClickMainButton = {
    next: () => {
      setModalIsOpen(true);
      if(state.lpMode && isSp){
        window.parent.postMessage({ action: 'scrollTo', scrollTarget: '.p-form' }, state.lpOrigin);
      }
    },
  };

  // ボタン押下
  // モーダル非表示
  const onClickCloseButton = () => setModalIsOpen(false);

  // モーダル上のボタン押下
  // state更新処理
  const onClickLastButton = (e) => {
    setShowLoding(true);
    const params = {
      ekiCd,
      ekiName,
      moveTypeCd,
      moveTime: Number(moveTime),
      moveTimeFromBusStop: Number(moveTimeFromBusStop),
      physicalCare,
      lifeSupport,
      otherWorkText,
      qualification,
      qualificationText,
      experience,
      fromDate: pendingFromDateFlag ? '2999/12/31' : fromDateStr,
      toDate: pendingToDateFlag ? '2999/12/31' : toDateStr,
      workStyle,
      minBusinessDay: Number(minBusinessDay),
      maxBusinessDay: Number(maxBusinessDay),
      dayOfTheWeek: dayOfTheWeek.map(w => Number(w)),
      workStyleInfo,
      canCommuteByCar: canCommuteByCar === '01',
      hourSalary: Number(hourSalary),
      suggestHourSalary,
      freeComment,
      corpName,
      facilityName,
      facilityType,
      capacity,
      userName,
      tel,
      email,
      zip,
      address,
    };
      
    // データ登録処理
    e.preventDefault();
    // 二重登録
    if(isRegistered) {
      setIsApiError(true);
      return false;
    };
    // Postパラメータチェック
    const [ isPostValid ] = isSchemaValid({ path: `${path}:post`, target: params });
    if(!isPostValid){
      setIsApiError(true);
      return false;
    };
    // ok
    dispatch({
      type: CHANGE_VALID, 
      path,
      valid: isPostValid,
    });


    // 更新処理
    postRegisterOrderApi({ params })
      .then(() => {
        history.push(THANKS_URL);
      })
      .catch(err => {
        // FATELエラーチェック
        const isFatal = isFatalApiError(err);
        setIsApiError(isFatal);
        if(isFatal) throw err;
          
        // 400エラーは基本的に起きないためFATAL
        if(err.response.status === 400) {
          setIsApiError(true);
          return false;
        };
        return false;
      });
    return true;
  };

  // 画面表示用のテキスト
  const confList = [
    {
      title: '就業先',
      modifyLinks: [ STATION_URL ],
      items: [ `${ekiName}駅 ${getChoiceLabel('moveTypeCdList', moveTypeCd)}${moveTime}分    ${moveTypeCd === '2' ? `バス停から徒歩${moveTimeFromBusStop}分` : '' }` ],
    },
    {
      title: '業務内容',
      modifyLinks: [ TYPE_URL ],
      type: 'withTitle',
      items: [
        { title: '身体介護', content: (
          getChoiceValues('physicalCareList')
            .filter(w => physicalCare.includes(w))
            .map(w => getChoiceLabel('physicalCareList', w))
            .join('・')
        ), fullWidth: true },
        { title: '生活援助', content: (
          getChoiceValues('lifeSupportList')
            .filter(w => lifeSupport.includes(w))
            .map(w => getChoiceLabel('lifeSupportList', w))
            .join('・')
        ), fullWidth: true },
        { title: 'その他', content: `${otherWorkText}`, fullWidth: true },
      ],
    },
    {
      title: '経験・スキル',
      modifyLinks: [ SKILL_URL ],
      type: 'withTitle',
      items: [
        { title: '介護経験', content: (
          getChoiceValues('experienceList')
            .filter(w => experience.includes(w))
            .map(w => getChoiceLabel('experienceList', w))
            .join('・')
        ) },
        { title: '介護資格', content: (
          getChoiceValues('qualificationList')
            .filter(w => qualification.includes(w))
            .map(w => getChoiceLabel('qualificationList', w))
            .join('・')
        ), fullWidth: true },
        { title: 'その他', content: `${qualificationText}`, fullWidth: true },
      ],
    },
    {
      title: '条件',
      modifyLinks: [ COND_URL ],
      type: 'withTitle',
      items: [
        { title: '期間', content: `${pendingFromDateFlag ? '未定' : fromDateStr} - ${pendingToDateFlag ? '未定' : toDateStr}` },
        { title: '就業形態', content: `${getChoiceLabel('workStyleList', workStyle)}` },
        { title: '就業日数/週', content: `${minBusinessDay}日 - ${maxBusinessDay}日` },
        { title: '就業曜日', content: (
          getChoiceValues('dayOfTheWeekList')
            .filter(w => dayOfTheWeek.includes(w))
            .map(w => getChoiceLabel('dayOfTheWeekList', w))
            .join('・')
        ) },
        { title: workStyle === '01' ? '就業時間' : shiftTitle, content: workStyle === '01' ? fixedInfo : shiftInfo, fullWidth: true },
        { title: '車通勤', content: `${getChoiceLabel('canCommuteByCarList', canCommuteByCar)}` },
        { title: '希望単価/時', content: `${Number(hourSalary).toLocaleString()}円` },
        { title: 'その他条件', content: `${freeComment}` },
      ],
    },
    {
      title: '詳細情報',
      modifyLinks: [ INFO_URL ],
      type: 'withTitle',
      items: [
        { title: '法人名', content: corpName, fullWidth: true },
        { title: '施設名', content: facilityName, fullWidth: true },
        { title: '施設種類', content: (
          getChoiceValues('facilityTypeList')
            .filter(w => facilityType.includes(w))
            .map(w => getChoiceLabel('facilityTypeList', w))
            .join('・')
        ), fullWidth: true },
        { title: '定員規模', content: `${getChoiceLabel('capacityList', capacity)}` },
        { title: 'ご担当者名', content: userName, fullWidth: true },
        { title: '電話番号', content: tel, fullWidth: true },
        { title: 'メール', content: email, fullWidth: true },
        { title: '市区町村', content: `${zip.length > 0 ? '〒' : '' }${zip}${zip.length > 0 ? ' ' : '' }${municipality}`, fullWidth: true },
        { title: '番地以降', content: `${houseNumber}`, fullWidth: true },
      ],
    },
  ];

  // 画面表示
  return(
    <div id='pageConf' ref={pageEl}>
      { isSp ? (
        <PresentSP 
          onClickMainButton={onClickMainButton}
          changeModifyMode={changeModifyMode}
          confList={confList}
          isApiError={isApiError}
          showLoading={showLoading}
          modalIsOpen={modalIsOpen}
          acknowledgeMap={ACKNOWLEDGE_MAP}
          onClickLastButton={onClickLastButton}
          onClickCloseButton={onClickCloseButton}
          lpMode={state.lpMode}
        />
      ) : (
        <PresentPC 
          onClickMainButton={onClickMainButton}
          changeModifyMode={changeModifyMode}
          confList={confList}
          isApiError={isApiError}
          showLoading={showLoading}
          modalIsOpen={modalIsOpen}
          acknowledgeMap={ACKNOWLEDGE_MAP}
          onClickLastButton={onClickLastButton}
          onClickCloseButton={onClickCloseButton}
          lpMode={state.lpMode}
        />
      )}
    </div>
  );
};

export default Conf;